import SubVisual from '@/components/SubVisual';
import FirstContent from '@/pages/price/components/FirstContent';
import SecondContent from '@/pages/price/components/SecondContent';
import ThirdContent from '@/pages/price/components/ThirdContent';
import FourthContent from '@/pages/price/components/FourthContent';
import FifthContent from '@/pages/price/components/FifthContent';

const PricePage = () => {
	return (
		<main id="sub" className="sub price">
			<SubVisual cate={'가격 정책'} title={'스텔라 요금 안내'} />
			<FirstContent />
			<SecondContent />
			<ThirdContent />
			{/* <FourthContent /> */}
			<FifthContent />
		</main>
	);
};

export default PricePage;
